import { useEffect, useState } from "react";
import api from "@/lib/api";
import Navbar from "@/components/Navbar";
import PromoBanner from "@/components/PromoBanner";
import { BadgeTile } from "@/components/BadgesGrid";

export default function Achievements() {
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/badges").then((r) => setData(r.data)).catch(() => {});
  }, []);

  const earned = data?.badges?.filter((b) => b.earned) || [];
  const locked = data?.badges?.filter((b) => !b.earned) || [];

  return (
    <div className="min-h-screen bg-background text-foreground">
      <PromoBanner />
      <Navbar />
      <main className="max-w-6xl mx-auto px-6 py-12">
        <div className="mb-10">
          <div className="text-xs uppercase tracking-[0.3em] font-bold text-brand-gold mb-3">Achievements</div>
          <h1 className="text-4xl lg:text-5xl font-black tracking-tight" data-testid="achievements-title">
            Your badges.
          </h1>
          {data && (
            <p className="mt-3 font-mono text-muted-foreground">
              <span className="font-bold text-black">{data.earned_count}</span> of <span className="font-bold text-black">{data.total}</span> unlocked.
              Keep practicing to earn more.
            </p>
          )}
        </div>

        {earned.length > 0 && (
          <section className="mb-12" data-testid="achievements-earned-section">
            <div className="text-xs uppercase tracking-[0.3em] font-bold mb-4">Unlocked ({earned.length})</div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
              {earned.map((b) => <BadgeTile key={b.id} badge={b} />)}
            </div>
          </section>
        )}

        {locked.length > 0 && (
          <section data-testid="achievements-locked-section">
            <div className="text-xs uppercase tracking-[0.3em] font-bold mb-4 text-muted-foreground">Locked ({locked.length})</div>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
              {locked.map((b) => <BadgeTile key={b.id} badge={b} />)}
            </div>
          </section>
        )}
      </main>
    </div>
  );
}
